import dynamic from 'next/dynamic'
import {FC, ComponentType} from 'react'

interface LeafletDynamicProps{
    defaultZoom?: number;
    height?: any;
    width?: any;
    center: any;
    children?: any;
    zIndex?: number;
    options?: {};
    markers?: any[];
}

export const LeafletMapDynamic:ComponentType<LeafletDynamicProps> = dynamic({
    loader: () => import('../web').then((mod) => mod.LeafletMap),
    loading: () => null,
    ssr: false
});


